import { useState } from 'react';
import { Clock, CheckCircle, XCircle, Eye, RotateCcw } from 'lucide-react';
import { RelatedArticles } from './realatedArticle';
import { InteractivePassage } from './howerwordmeaning';

export const SolutionScreen = ({ testData, answers, relatedArticles, backToResults, resetTest }) => {
  
  // Render passage text without translation functionality
  
  const renderPassage = (text) => {
    if (!text) return null;
    return (
  //     <div style={styles.solutionContainer}>
  // <h2 style={styles.solutionTitle}>📖 Reading Passage</h2>
  <InteractivePassage text={testData.passage} />
// </div>

    );
  };

  const renderQuestionSolution = (question) => {
    const userAnswer = answers[question.id];
    const isCorrect = checkAnswerCorrectness(question, userAnswer);
    const wasAttempted = userAnswer !== undefined;

    switch (question.type) {
      case 'mcq':
        return renderMCQSolution(question, userAnswer, isCorrect, wasAttempted);
      case 'fillBlank':
        return renderFillBlankSolution(question, userAnswer, isCorrect, wasAttempted);
      case 'multipleChoiceFillBlank':
        return renderMultipleChoiceFillBlankSolution(question, userAnswer, isCorrect, wasAttempted);
      default:
        return renderMCQSolution(question, userAnswer, isCorrect, wasAttempted);
    }
  };

  const checkAnswerCorrectness = (question, userAnswer) => {
    if (userAnswer === undefined) return false;
    
    switch (question.type) {
      case 'mcq':
        return userAnswer === question.correct;
      case 'fillBlank':
        if (!Array.isArray(userAnswer)) return false;
        return question.blanks.every((blank, index) => 
          userAnswer[index]?.toLowerCase() === blank.correct?.toLowerCase()
        );
      case 'multipleChoiceFillBlank':
        return userAnswer?.toLowerCase() === question.correct?.toLowerCase();
      default:
        return userAnswer === question.correct;
    }
  };

  const renderMCQSolution = (question, userAnswer, isCorrect, wasAttempted) => {
    return (
      <>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
          {question.options.map((option, optionIndex) => {
            const isUserAnswer = userAnswer === optionIndex;
            const isCorrectAnswer = question.correct === optionIndex;
            
            return (
              <div
                key={optionIndex}
                style={
                  isCorrectAnswer
                    ? styles.correctOption
                    : isUserAnswer && !isCorrectAnswer
                    ? styles.incorrectOption
                    : styles.regularOption
                }
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span>{option}</span>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    {isCorrectAnswer && (
                      <CheckCircle style={{ width: '20px', height: '20px', color: '#16a34a' }} />
                    )}
                    {isUserAnswer && !isCorrectAnswer && (
                      <XCircle style={{ width: '20px', height: '20px', color: '#dc2626' }} />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        
        <div style={{ 
          backgroundColor: '#eff6ff', 
          padding: '16px', 
          borderRadius: '8px'
        }}>
          <h4 style={{ fontWeight: '600', color: '#1e40af', marginBottom: '8px' }}>Your Performance:</h4>
          <div style={{ fontSize: '14px', color: '#1e40af' }}>
            <p><strong>Your Answer:</strong> {wasAttempted ? question.options[userAnswer] : 'Not attempted'}</p>
            <p><strong>Correct Answer:</strong> {question.options[question.correct]}</p>
            <p><strong>Result:</strong> <span style={{ 
              color: isCorrect ? '#16a34a' : '#dc2626'
            }}>
              {isCorrect ? 'Correct' : wasAttempted ? 'Incorrect' : 'Not Attempted'}
            </span></p>
          </div>
        </div>
      </>
    );
  };

  const renderFillBlankSolution = (question, userAnswer, isCorrect, wasAttempted) => {
    // Format the question text with correct answers
    let formattedQuestion = question.question;
    
    // Replace each blank with the correct answer
    question.blanks.forEach((blank, index) => {
      const correctAnswer = blank.correct;
      formattedQuestion = formattedQuestion.replace(
        '__________', 
        `<strong style="color: #16a34a">${correctAnswer}</strong>`
      );
    });

    // Generate user answer display
    const userAnswerDisplay = wasAttempted 
      ? question.blanks.map((blank, index) => userAnswer[index] || '______').join(' and ')
      : 'Not attempted';

    // Generate correct answer display
    const correctAnswerDisplay = question.blanks.map(blank => blank.correct).join(' and ');

    return (
      <>
        <div style={{ 
          backgroundColor: '#f9fafb',
          padding: '16px',
          borderRadius: '8px',
          marginBottom: '16px'
        }}>
          <div dangerouslySetInnerHTML={{ __html: formattedQuestion }} />
        </div>
        
        <div style={{ 
          backgroundColor: '#eff6ff', 
          padding: '16px', 
          borderRadius: '8px'
        }}>
          <h4 style={{ fontWeight: '600', color: '#1e40af', marginBottom: '8px' }}>Your Performance:</h4>
          <div style={{ fontSize: '14px', color: '#1e40af' }}>
            <p>
              <strong>Your Answer:</strong> {userAnswerDisplay}
            </p>
            <p><strong>Correct Answer:</strong> {correctAnswerDisplay}</p>
            <p><strong>Result:</strong> <span style={{ 
              color: isCorrect ? '#16a34a' : '#dc2626'
            }}>
              {isCorrect ? 'Correct' : wasAttempted ? 'Incorrect' : 'Not Attempted'}
            </span></p>
          </div>
        </div>
      </>
    );
  }; 

  const renderMultipleChoiceFillBlankSolution = (question, userAnswer, isCorrect, wasAttempted) => {
    return (
      <>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '16px' }}>
          {question.options.map((option, optionIndex) => {
            const isUserAnswer = userAnswer === option;
            const isCorrectAnswer = question.correct === option;
            
            return (
              <div
                key={optionIndex}
                style={
                  isCorrectAnswer
                    ? styles.correctOption
                    : isUserAnswer && !isCorrectAnswer
                    ? styles.incorrectOption
                    : styles.regularOption
                }
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span>{option}</span>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    {isCorrectAnswer && (
                      <CheckCircle style={{ width: '20px', height: '20px', color: '#16a34a' }} />
                    )}
                    {isUserAnswer && !isCorrectAnswer && (
                      <XCircle style={{ width: '20px', height: '20px', color: '#dc2626' }} />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        
        <div style={{ 
          backgroundColor: '#eff6ff', 
          padding: '16px', 
          borderRadius: '8px'
        }}>
          <h4 style={{ fontWeight: '600', color: '#1e40af', marginBottom: '8px' }}>Your Performance:</h4>
          <div style={{ fontSize: '14px', color: '#1e40af' }}>
            <p><strong>Your Answer:</strong> {wasAttempted ? userAnswer : 'Not attempted'}</p>
            <p><strong>Correct Answer:</strong> {question.correct}</p>
            <p><strong>Result:</strong> <span style={{ 
              color: isCorrect ? '#16a34a' : '#dc2626'
            }}>
              {isCorrect ? 'Correct' : wasAttempted ? 'Incorrect' : 'Not Attempted'}
            </span></p>
          </div>
        </div>
      </>
    );
  };

  const styles = {
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      padding: '32px'
    },
    title: {
      fontSize: '36px',
      fontWeight: '700',
      color: '#1f2937',
      marginBottom: '16px'
    },
    button: {
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      padding: '12px 32px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontSize: '16px',
      transition: 'background-color 0.2s'
    },
    buttonHover: {
      backgroundColor: '#1d4ed8'
    },
    buttonSecondary: {
      backgroundColor: '#4b5563',
      color: 'white'
    },
    buttonSecondaryHover: {
      backgroundColor: '#374151'
    },
    solutionContainer: {
      backgroundColor: '#eff6ff',
      padding: '16px',
      borderRadius: '8px',
      borderLeft: '4px solid #3b82f6',
      marginBottom: '32px',
      position: 'relative'
    },
    solutionTitle: {
      fontSize: '20px',
      fontWeight: '700',
      color: '#1e40af',
      marginBottom: '16px'
    },
    questionTitle: {
      fontSize: '20px',
      fontWeight: '600',
      marginBottom: '16px'
    },
    correctOption: {
      backgroundColor: '#dcfce7',
      borderColor: '#22c55e',
      color: '#166534',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid',
      marginBottom: '8px'
    },
    incorrectOption: {
      backgroundColor: '#fee2e2',
      borderColor: '#ef4444',
      color: '#991b1b',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid',
      marginBottom: '8px'
    },
    regularOption: {
      backgroundColor: '#f9fafb',
      borderColor: '#e5e7eb',
      padding: '12px',
      borderRadius: '8px',
      border: '1px solid',
      marginBottom: '8px'
    },
    questionNumber: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontWeight: '700',
      marginRight: '16px'
    },
    questionNumberCorrect: {
      backgroundColor: '#16a34a'
    },
    questionNumberIncorrect: {
      backgroundColor: '#dc2626'
    },
    questionNumberUnattempted: {
      backgroundColor: '#9ca3af'
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '32px' }}>
      {/* Left Side - Solutions */}
      <div style={{ flex: '2 1 0%', minWidth: 0 }}>
        <div style={styles.card}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px' }}>
            <h1 style={styles.title}>Detailed Solutions</h1>
            <button
              onClick={backToResults}
              style={{
                ...styles.button,
                ...styles.buttonSecondary
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.buttonSecondary.backgroundColor}
            >
              Back to Results
            </button>
          </div>
          
          {/* Passage Section - Simplified */}
          <div style={styles.solutionContainer}>
            <h2 style={styles.solutionTitle}>📖 Reading Passage</h2>
            {renderPassage(testData.passage)}
          </div>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            {testData.questions.map((question, index) => {
              const userAnswer = answers[question.id];
              const isCorrect = checkAnswerCorrectness(question, userAnswer);
              const wasAttempted = userAnswer !== undefined;
              
              return (
                <div key={question.id} style={{ 
                  borderBottom: '1px solid #e5e7eb', 
                  paddingBottom: '32px',
                  ':last-child': {
                    borderBottom: 'none'
                  }
                }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', marginBottom: '16px' }}>
                    <div style={{
                      ...styles.questionNumber,
                      ...(isCorrect ? styles.questionNumberCorrect : 
                          wasAttempted ? styles.questionNumberIncorrect : 
                          styles.questionNumberUnattempted)
                    }}>
                      {index + 1}
                    </div>
                    <div style={{ flex: 1 }}>
                      <h3 style={styles.questionTitle}>{question.question}</h3>
                      {renderQuestionSolution(question)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          
          <div style={{ marginTop: '32px', textAlign: 'center' }}>
            <button
              onClick={resetTest}
              style={styles.button}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = styles.buttonHover.backgroundColor}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = styles.button.backgroundColor}
            >
              Take Another Test
            </button>
          </div>
        </div>
      </div>
      {/* <InteractivePassage text={testData.passage}/> */}
      {/* Right Side - Related Articles */}
      <div style={{ flex: '1 1 0%', minWidth: '300px' }}>
        <RelatedArticles articles={relatedArticles} />
      </div>
    </div>
  );
};